/**
 * Student Topic Page — עמוד נושא (/learn/topic/:slug)
 *
 * Thin wrapper over the generic track topic page; see TrackTopicPage.
 */

import TrackTopicPage from './track/TrackTopicPage'

export default function StudentTopicPage() {
  return <TrackTopicPage track="student" />
}
